import ArrowButton from '@/components/molecules/arrowButton'
import Description from './description'
import Title from './title'

const Content = ({ title, description, ctaButton }) => {
  return (
    <div className="w-full w-full lg:max-w-[400px] flex flex-col lg:justify-between">
      <div className="w-full">
        <Title text={title} />
        <Description description={description} />
      </div>
      <ArrowButton
        name={ctaButton.name}
        link={ctaButton.link}
        target="_blank"
        className="mt-smallMobile lg:mt-0 lg:mb-smallDesktop"
      />
    </div>
  )
}

export default Content
